const classParent = 'js-collapse-description';
const classInitialized = 'js-collapse-description--initialized';
const classAccordion = 'js-collapse-description__accordion';
const classAccordionOpen = 'js-collapse-description__accordion--open';

const expandText = 'Read More';
const collapseText = 'Read Less';

document.querySelectorAll(`.${classParent}`).forEach(description => {
  init(description);
});

/** @param {HTMLElement} element */
function init(element) {
  // Hide all but first child element
  const hiddenChildren = [...element.children];
  hiddenChildren.shift();

  if (hiddenChildren.length > 0) {
    // Create wrapper for collapsed items
    const accordion = document.createElement('div');
    accordion.replaceChildren(...hiddenChildren);
    accordion.classList.add(classAccordion);
    element.appendChild(accordion);

    // Create expand button
    const expandBtn = document.createElement('a');
    expandBtn.innerText = expandText;
    expandBtn.setAttribute('href', '#');

    // Expand/collapse on click
    expandBtn.addEventListener('click', () => {
      if (accordion.classList.contains(classAccordionOpen)) {
        // close
        accordion.classList.remove(classAccordionOpen);
        expandBtn.innerText = expandText;
      } else {
        // open
        accordion.classList.add(classAccordionOpen);
        expandBtn.innerText = collapseText;
      }
    });

    element.appendChild(expandBtn);
  }

  // Ready to go
  element.classList.add(classInitialized);
}
